// extracted by mini-css-extract-plugin
export default {"root":"TopbarSimplified_root__aJIZm","back":"TopbarSimplified_back__XxiqB"};